import { useQuery } from '@tanstack/react-query'
import { resolveLoyaltyDomain } from '~/lib/loyalty-domain'

const LOYALTY_API_URL = process.env.NEXT_PUBLIC_LOYALTY_API_URL
const NEXT_PUBLIC_DOMAIN_URL = process.env.NEXT_PUBLIC_DOMAIN_URL

export interface LoyaltyProperty {
  id: string
  legal_entity_id: string
  code: string
  name: string
  timezone: string
  crs_hotel_id: number
}

async function fetchLoyaltyProperties(domain: string): Promise<LoyaltyProperty[]> {
  // GET /public/properties (public, unauthenticated) — danh sách property của tenant,
  // dùng để resolve property_code (field `code`) cho /public/loyalty-notice qua crs_hotel_id.
  const res = await fetch(
    `${LOYALTY_API_URL}/public/properties?domain=${encodeURIComponent(NEXT_PUBLIC_DOMAIN_URL ?? domain)}`
  )
  if (!res.ok) return []
  return res.json()
}

// Danh sách property hiếm khi đổi → cache dài (30') theo domain, dùng chung cho mọi
// component gọi useLoyaltyNotice thay vì fetch lại mỗi lần.
export function useLoyaltyProperties() {
  const domain = resolveLoyaltyDomain()

  return useQuery<LoyaltyProperty[]>({
    queryKey: ['loyalty-properties', domain],
    queryFn: () => fetchLoyaltyProperties(domain as string),
    enabled: !!LOYALTY_API_URL && !!domain,
    staleTime: 30 * 60 * 1000,
    retry: false,
  })
}

// Đối chiếu hotelId (CRS) với crs_hotel_id trả về từ Loyalty để lấy property_code (`code`).
// Trả null nếu chưa có data / không tìm thấy match — loyalty-notice call sẽ tự skip thay vì
// gửi guessed code (xem comment trong use-loyalty-notice.ts).
export function getLoyaltyPropertyCode(
  properties: LoyaltyProperty[] | undefined,
  hotelId?: string | number | null
): string | null {
  if (hotelId === null || hotelId === undefined || hotelId === '' || !properties) return null
  const match = properties.find((p) => String(p.crs_hotel_id) === String(hotelId))
  return match?.code ?? null
}
